export { default } from 'features/partners-walmart/routes/walmart-location-route';
